export default __webpack_public_path__ + "static/Inter-Regular-da5e42ad44b11496ef7cb32e26647850.woff2";